import classNames from "classnames"
import { LabelProps } from "../../types/LabelProps"

export interface Props extends LabelProps {
  className?: string
}

export function FormLabel({ children, className, ...rest }: Props) {
  return (
    <label
      className={classNames(
        "text-[color:var(--alias-color-text-weak)] [font-family:var(--alias-font-label-strong-font-weight)] [font-size:var(--alias-font-label-strong-font-size)]",
        className,
      )}
      {...rest}
    >
      {children}
    </label>
  )
}
